import { render } from "./loading-spinner.vue?vue&type=template&id=40c44878&scoped=true"
import script from "./loading-spinner.vue?vue&type=script&lang=js"
export * from "./loading-spinner.vue?vue&type=script&lang=js"

import "./loading-spinner.vue?vue&type=style&index=0&id=40c44878&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c44878"]])

export default __exports__